/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {

};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    getRechargeCodeList({ commit, rootState }, params) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        return rootState.$helper.request.get(`/games/${gameCode}/activity/list`, params, (res) => {
            return true;
        })
    },
    createdRechargeCode({ commit, rootState }, params) {
        return rootState.$helper.request.filePost('/games/{game_code}/activity/create', params)
    },
    editRechargeCode({ commit, rootState }, params) {
        return rootState.$helper.request.filePost('/games/{game_code}/activity/edit', params)
    },
    changeStatusAction({ commit, rootState }, params) {
        return rootState.$helper.request.post('/games/{game_code}/activity/change-status', params)
    },
    addCode({ commit, rootState }, params) {
        return rootState.$helper.request.filePost('/games/{game_code}/activity/add-code', params)
    },
    removeActivity({ commit, rootState }, params) {
        return rootState.$helper.request.delete('/games/{game_code}/activity/delete/' + params.id)
    },
    getActivityDetails({ commit, rootState }, params) {
        return rootState.$helper.request.get('/games/{game_code}/activity/get/' + params.id)
    },
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {

};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./website/store/modules/recharge/createRechargeCode.js